import { gql } from "@apollo/client";

export const GET_VM_COST_HISTORY = gql`
  query GetVmCostHistory($index: Int!) {
    getVmCostHistory(index: $index) {
      index
      hasNext
      hasPrevious
      months
      vmCostHistory {
        vmId
        vmName
        costs
      }
    }
  }
`;

export const GET_VM_COSTS_BY_MONTH_AND_YEAR = gql`
  query GetVmCostsByMonthAndYear($year: Int, $month: Int) {
    getVmCostsByMonthAndYear(year: $year, month: $month) {
      vmId
      vmName
      totalCost
    }
  }
`;

export const GET_VM_COST_DETAIL = gql`
  query GetVmCostDetail($vmId: ID!, $year: Int!, $month: Int!) {
    getVmCostDetail(vmId: $vmId, year: $year, month: $month) {
      vmId
      vmName
      directCost
      reservationCost
      sharedCost
      totalCost
    }
  }
`;

export const GET_VM_COSTS_BY_SERVICE_FOR_VM = gql`
  query GetVmCostsByServiceForVm($vmId: ID!, $year: Int!, $month: Int!) {
    getVmCostsByServiceForVm(vmId: $vmId, year: $year, month: $month) {
      serviceName
      totalCost
    }
  }
`;

export const GET_VM_COST_HISTORY_BY_DATE_RANGE = gql`
  query GetVmCostHistoryByDateRange(
    $vmId: ID!
    $startDate: String!
    $endDate: String!
  ) {
    getVmCostHistoryByDateRange(
      vmId: $vmId
      startDate: $startDate
      endDate: $endDate
    ) {
      vmId
      vmName
      costs {
        date
        totalCost
      }
    }
  }
`;

export const GET_MONTHLY_COSTS_BY_DATE_RANGE = gql`
  query GetMonthlyCostsByDateRange(
    $vmId: ID!
    $startDate: String!
    $endDate: String!
  ) {
    getMonthlyCostsByDateRange(
      vmId: $vmId
      startDate: $startDate
      endDate: $endDate
    ) {
      isAllVms
      months
      vmCosts {
        vmId
        vmName
        costs
      }
      vmId
      vmName
      costs
    }
  }
`;

export const GET_TOTAL_COST_FOR_VMS = gql`
  query GetTotalCostForVms(
    $vmIds: [ID!]!
    $startMonth: Int!
    $startYear: Int!
    $endMonth: Int!
    $endYear: Int!
  ) {
    getTotalCostForVms(
      vmIds: $vmIds
      startMonth: $startMonth
      startYear: $startYear
      endMonth: $endMonth
      endYear: $endYear
    ) {
      totalAmount
      vmDetails {
        vmId
        vmName
        totalAmount
      }
    }
  }
`;
